<template>
  <div>
    <div
      class="strip_all_tour_list wow fadeIn"
      data-wow-delay="0.1s"
      style="visibility: visible; animation-delay: 0.1s; animation-name: fadeIn"
    >
      <div class="row">
        <div class="col-lg-9 col-md-9">
          <div class="cust_tour_list_desc tour_list_desc">
            
            <div
              v-for="(item, index) in roomRequest"
              :key="index"
              class="room-details"
            >
              <div class="room-desc">
                <span id="title">اتاق {{ index + 1 }}</span>

                <div id="capacity">
                  <i class="pax-icon icon-adult"></i> بزرگسال:
                  <span>{{ item[1].adults }}</span>
                </div>
                <div id="exterabed">
                  <i class="pax-icon icon-child"></i> کودک :
                  <span>{{ item[1].children }}</span>
                </div>
                <div id="exterabed">
                  <i class="pax-icon icon-child"></i> نوزاد :
                  <span>{{ item[1].infant }}</span>
                </div>
              </div>
              <div style="margin: auto" class="col-md-9">
                <div
                  style="margin-top: 25px; margin-bottom: 30px"
                  class="form-group"
                >
                  <label
                    ><i style="color: #0a6c9f" class="icon-check-1"></i>انتخاب
                    اتاق</label
                  >
                  <select
                    v-model="selected[index]"
                    @change="onChangeRoomType(index, selected[index], item[1])"
                    id="roomTypes"
                    class="form-control"
                    name="country"
                  >
                    <!-- <option selected> یک اتاق را انتخاب کنید</option> -->
                    <option
                      v-for="(opt, indexOpt) in item[0]"
                      :key="indexOpt"
                      v-bind:value="opt"
                      v-bind:selected="opt.selected"
                    >
                      {{ opt.name }} <span> /{{ opt.capacity }} تخته </span>
                    </option>
                  </select>
                </div>
              </div>

              <div v-if="showDetail" class="container-fluid room-type-detail">
                <transition name="fade">
                  <div class="row bed-details">
                    <i class="icon-lodging"></i>
                    <div class="bed">
                      <span>{{ selected[index].capacity }}</span>
                      <label> تخته</label>
                    </div>
                    <div
                      v-if="
                        item[1].adults +
                          item[1].children -
                          selected[index].capacity >
                          0 && selected[index].maximumExtraBed > 0
                      "
                      class="extrabed"
                    >
                      <label>به همراه</label
                      ><span>{{
                        item[1].adults +
                        item[1].children -
                        selected[index].capacity
                      }}</span
                      ><label>تخت اضافه</label>
                    </div>

                    <div class="icon_features">
                      <div
                        v-if="selected[index].breakfastIncluded === true"
                        class="tooltip_flip tooltip-effect-1 option the-icons"
                      >
                        <i class="room-fac-icon icon_set_1_icon-61"></i>

                        <span
                          style="margin-bottom: 29px"
                          class="tooltip-content-flip"
                          ><span style="font-size: 11px" class="tooltip-back"
                            >صبحانه
                          </span></span
                        >
                      </div>

                      <div
                        style="margin-top: -2px"
                        v-if="selected[index].smoking === false"
                        class="tooltip_flip tooltip-effect-1 option the-icons"
                      >
                        <i
                          style="font-size: 28px"
                          class="room-fac-icon icon_set_1_icon-47"
                        ></i>

                        <span
                          style="margin-bottom: 29px"
                          class="tooltip-content-flip"
                          ><span style="font-size: 11px" class="tooltip-back"
                            >سیگار ممنوع
                          </span></span
                        >
                      </div>
                    </div>

                    <!-- <div
                      v-if="selected[index].breakfastIncluded === true"
                      class="breakfast the-icons"
                    >
                      <i style="font-size: 16px;margin-left: 2px;" class="icon-coffee"></i>
                      <span class="i-name">صبحانه رایگان</span>
                    </div> -->
                  </div>
                </transition>

                <transition name="fade">
                  <div class="price-details">
                    <div style="margin-right: -15px">
                      <span>به ازای هرشب:</span>
                      <span>{{
                        selected[index].basePrice | numFormat | rial
                      }}</span>
                    </div>

                    <div
                      style="margin: auto; margin-top: 5px"
                      class="row"
                      v-if="
                        item[1].adults +
                          item[1].children -
                          selected[index].numberOfBeds >
                          0 && selected[index].maximumExtraBed > 0
                      "
                    >
                      <div style="margin-left: 40px" class="row">
                        <span>تخت اضافه :</span>
                        <span>{{
                          selected[index].rackExtraBedPrice | numFormat | rial
                        }}</span>
                      </div>
                      <div v-if="item[1].children === 0" class="row">
                        <span>تخت اضافه کودک:</span>
                        <span>{{
                          selected[index].rackChildPrice | numFormat | rial
                        }}</span>
                      </div>
                    </div>
                  </div>
                </transition>

                <transition name="fade">
                  <div
                    v-if="selected[index].amenities.length > 0"
                    style="margin-top: 10px"
                  >
                    <i class="icon_color icon-quote-left-alt"></i>
                    <span class="amenities"> امکانات اتاق : </span>
                    <!-- <div>{{selected[index].name}}</div> -->
                    <label
                      v-for="(item, amenitiesIndex) in selected[index]
                        .amenities"
                      :key="amenitiesIndex"
                    >
                      <span style="margin-left: 2px"> {{ item }}،</span>
                    </label>
                  </div>

                  <div
                    class="room_desc"
                    v-if="selected[index].description !== ''"
                  >
                    <i class="icon_color icon-pin"></i>

                    <span id="title"> توضیحات : </span>
                    <label>{{ selected[index].description }}</label>
                  </div>
                </transition>
              </div>

              <hr v-if="roomRequest.length > 1" class="hr-style" />
            </div>
          </div>
        </div>
        <div class="row select-btn col-lg-3 col-md-3">
          <div class="room_price">
            <div>
              <!-- <span v-if="totalPrice>0" class="normal_price_list"><label>قیمت پایه :</label> {{ selected[index].basePrice | numFormat | rial  }}</span> -->

              <span v-if="totalRackPrice > 0" class="normal_price_list">{{
                totalRackPrice | numFormat | rial
              }}</span>
              <span v-if="totalRackPrice > 0">{{
                totalRoomPrice | numFormat | rial
              }}</span>
              <small v-if="totalRackPrice > 0">به ازای هر شب</small>
              <button
                v-if="isDisableButton"
                disabled
                class="cust_btn btn btn-block btn-primary"
                style="width: 200px; margin: auto"
              >
                انتخاب
              </button>
              <button
                v-else
                @click="onSelectRoomTest()"
                class="cust_btn btn btn-block btn-primary"
              >
                انتخاب
              </button>
              <span v-if="remainRoom > 0" class="remain-room-title"
                >{{ remainRoom }} انتخاب باقی مانده
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="card">
    <div class="row no-gutters">
      
     
    </div>
  </div> -->
</template>

<script>
export default {
  data: () => ({
    selectDefault: "یک اتاق انتخاب کنید",
    roomSelceted: [],
    selected: [],
    roomType: [],
    isHideRoom: {},
    roomCount: 1,
    showDetail: false,
    isValidCombining: false,
    remainRoom: Number,
    roomPrice: [],
    rackPrice: [],
    childWithPrice: [],
    totalRoomPrice: 0,
    totalRackPrice: 0,
  }),
  watch: {
    selected: function (value) {
      
      this.remainRoom = value.length;
      value.forEach((element) => {
        // debugger
        if (element.roomTypeCode > 0) {
          this.remainRoom = this.remainRoom - 1;
          this.isValidCombining = false;
        }
        if (this.remainRoom === 0) {
          this.isValidCombining = true;
        }
      });
    },
  },
  components: {},
  name: "pdkHotelRoomCard",
  props: {
    isDisableButton: Boolean,
    rooms: Array,
    roomRequest: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  computed: {
  },
  methods: {
    onSelectRoomTest() {
      if (!this.isValidCombining) {
        return;
      }

      this.$emit("selected", this.roomSelceted);
    },
    testChangeRoom(e) {},
    onSelectRoom(id, room, roomDetail) {
      if (!this.isValidCombining) {
        return;
      }
      const pax = roomDetail.adult + roomDetail.children;
      const bedsCount = room.capacity;
      const extrabed = room.maximumExtraBed;
      const capacity = pax - bedsCount;
      var selectedExtraBed = 0;
      if (capacity > 0 && extrabed > 0) {
        selectedExtraBed = capacity;
      }
      var selectedRoomModel = {
        roomId: id,
        roomRequest: {
          adults: roomDetail.adults,
          children: roomDetail.children,
          infants: roomDetail.infants,
        },
        numberOfBeds: bedsCount,
        numberOfExtraBed: selectedExtraBed,
        name: room.name,
        amenities: room.amenities,
        breakfastIncluded: room.breakfastIncluded,
        smoking: room.smoking,
      };

      this.$emit("onSelect", selectedRoomModel);
    },
    onChangeRoomType(index, room, roomDetail) {
      debugger
      // this run when the select in "I choose Myself" clicked and get the room datas and get the results 
      var noneFreeInfant = 0;
      var noneFreeChild = 0;
      var children = roomDetail.children;
      var forFreeChild = roomDetail.forFreeChild;
      if (roomDetail.infant > 1) {
        noneFreeInfant = roomDetail.infant - 1;
      } else {
        noneFreeInfant = 0;
      }

      if (noneFreeInfant >= 1 && forFreeChild == 0) {
        forFreeChild = forFreeChild + 1;
        noneFreeInfant = noneFreeInfant - 1;
      }

      if (forFreeChild > 0 && children == 0) {
        children = forFreeChild;
      }
      if (forFreeChild > 1) {
        noneFreeChild = forFreeChild - 1;
      } else {
        noneFreeChild = 0;
      }
      var childPriceCount = 0;

      childPriceCount =
        noneFreeInfant + roomDetail.olderThanChildAge + noneFreeChild;
      const pax = roomDetail.adults + childPriceCount;
      const bedsCount = room.capacity;
      const extrabed = room.maximumExtraBed;
      const capacity = pax - bedsCount;
      const basePrice = room.basePrice;
      const discount = room.discount;

      var selectedExtraBed = 0;
      var childPrice = 0;
      var rackChildPrice = 0;

      var extraBedPrice = 0;
      var rackExtraBedPrice = 0;

      // noneFreeInfant + olderThanChildAge + noneFreeChild;
      if (capacity > 0 && extrabed > 0) {
        selectedExtraBed = capacity;

        if (childPriceCount === selectedExtraBed) {
          childPrice = room.childPrice * childPriceCount;
          rackChildPrice = room.rackChildPrice * childPriceCount;
          extraBedPrice = 0;
        } else {
          if (childPriceCount > selectedExtraBed) {
            childPrice = room.childPrice * (childPriceCount - selectedExtraBed);
            rackChildPrice =
              room.rackChildPrice * (childPriceCount - selectedExtraBed);
          } else if (
            childPriceCount < selectedExtraBed &&
            childPriceCount > 0
          ) {
            childPrice = room.childPrice * childPriceCount;
            rackChildPrice = room.rackChildPrice * childPriceCount;

            extraBedPrice =
              room.extraBedPrice * (selectedExtraBed - childPriceCount);
            rackExtraBedPrice =
              room.rackExtraBedPrice * (selectedExtraBed - childPriceCount);
          } else if (
            childPriceCount < selectedExtraBed &&
            childPriceCount === 0 &&
            children === 0
          ) {
            extraBedPrice = room.extraBedPrice * selectedExtraBed;
            rackExtraBedPrice = room.rackExtraBedPrice * selectedExtraBed;
          }
        }
      }

      var total = basePrice - discount + childPrice + extraBedPrice;
      var totalRackPrice = basePrice + rackChildPrice + rackExtraBedPrice;

      this.roomPrice[index] = total;
      this.rackPrice[index] = totalRackPrice;
      this.showDetail = true;
      this.totalRoomPrice = this.roomPrice.reduce((acc, item) => acc + item, 0);
      this.totalRackPrice = this.rackPrice.reduce((acc, item) => acc + item, 0);
      this.roomSelceted[index] = room;
      this.roomSelceted[index].numberOfExtraBed = selectedExtraBed;
      this.roomSelceted[index].totalBasePrice = totalRackPrice;
      this.roomSelceted[index].totalFarePrice = total;
      this.roomSelceted[index].numberOfAdult = roomDetail.adults;
      this.roomSelceted[index].numberOfChild = roomDetail.children;
      this.roomSelceted[index].numberOfInfant = roomDetail.infant;
      this.roomSelceted[index].childWithPrice = childPriceCount;

      // this.roomType[val] = JSON.parse(JSON.stringify(this.selected[val]));
    },
    incRoomCount() {
      this.roomCount++;
    },
    decRoomCount() {
      if (this.roomCount > 1) {
        this.roomCount--;
      }
    },
  },
  created() {
    var i;
    for (i = 0; i < this.roomRequest.length; i++) {
      this.selected.push({
        adultQuantity: 0,
        amenities: [],
        basePrice: 0,
        breakfastIncluded: false,
        capacity: 0,
        childExtraBedQuantity: 1,
        childPrice: 0,
        discount: 0,
        extraBedPrice: 0,
        extraBedQuantity: 0,
        extraBedTotalPrice: 0,
        hotelName: "",
        maximumExtraBed: 0,
        minimumSalablePrice: 0,
        name: "یک اتاق انتخاب کنید",
        numberOfAvailableRooms: 0,
        numberOfBeds: 0,
        numberOfRoom: 0,
        numberOfAdult: 0,
        numberOfChild: 0,
        priceInclusion: 0,
        priceInclusionNote: "",
        rackChildPrice: 0,
        roomPrice: 0,
        roomTotalPrice: 0,
        roomTypeCode: 0,
        smoking: false,
        valueAddOn: "",
        vatIncluded: false,
        view: "",
      });
    }
    //  const dummyArray = Array(this.roomRequest.length);
    // this.selected.push(...dummyArray);
  },
};
</script>
<style scoped>
  @media only screen and (max-width: 750px) {
    .room_price div {
      padding-left: 0px !important;
    }
    .room_price {
      margin-top: -22px;
    }
  }
  .icon_features {
    left: 40px;
    position: absolute;
    display: inherit;
  }
  .room-detail {
    margin-top: 10px;
  }

  .room_desc {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .room_price small {
    font-size: 11px;
    color: #999;
    display: block;
    margin-bottom: 10px;
    line-height: 12px;
  }
  .room_price div {
    display: table-cell;
    /* vertical-align: middle; */
    text-align: center;
    padding-left: 25px;
  }
  .room_price {
    margin-left: inherit;
    /* margin-right: -15px; */
  }
  .room_price {
    display: table;
    /* height: 220px; */
    font-size: 18px;
    color: #217d0d;
    width: 50%;
    margin: auto;
  }
  .room_price .normal_price_list {
    display: block;
    text-decoration: line-through;
    color: #999;
    font-size: 20px;
    margin-top: 10px;
  }

  .remain-room-title {
    margin: auto;
    color: #00c3e1;
    text-align: center;
    margin-top: 4px;
    font-size: 14px !important;
  }
  .hr-style {
    border: 0;
    height: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }

  .room-type-detail {
    margin-top: 25px;
    background: #fbfbfb;
    padding: 10px;
    margin: 4px;
  }
  .breakfast {
    position: absolute;
    left: 0;
    margin-left: 40px;
    margin-top: -3px !important;
  }
  .bed-details {
    margin-right: 0px !important;
    font-size: 14px;
  }
  .bed-details i {
    color: black;
    font-size: 18px;
    margin-top: -3px;
  }
  .bed-details .bed span {
    color: #0a6c9f;
  }

  .bed-details .bed label {
    margin-left: 3px;
  }
  .bed-details .extrabed label {
    margin-left: 3px;
  }
  .bed-details .extrabed span {
    margin-left: 3px;
    color: #0a6c9f;
  }
  .amenities {
    color: #888888;
    font-weight: bold;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.9s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  select option label {
    border: 1px solid #000;
    background: #010;
  }
  .pax-icon {
    color: #909090;
  }
  .cust_btn {
    color: white !important;
    background: #084a6a !important;
    transition: 0.4s;
  }
  .cust_btn:hover {
    background: #03264d !important;
  }
  #room-count input {
    height: 30px !important;
  }
  #room-count div {
    height: 30px !important;
  }

  .icon_color {
    color: #0a6c9f;
  }

  .cust_tour_list_desc {
    height: auto;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  .select-btn {
    margin-top: auto;
    margin-bottom: 20px;
    margin-right: 15px;
  }
  .feature-list {
    position: absolute;
    left: 15px;
    display: flex !important;
  }
  .room-desc {
    display: flex;
    margin-bottom: 10px !important;
  }
  .room-desc #title {
    color: #0a6c9f;
  }
  .room-desc #capacity {
    margin: 0px 5px 0px 5px !important;
    color: #898989d1 !important;
    font-size: 15px !important;
  }
  .room-desc #exterabed {
    margin: 0px 5px 0px 5px !important;
    color: #898989d1 !important;
    font-size: 15px !important;
  }
  .room-divider {
    text-align: center;
    height: 1px;
    margin: 10px 0 10px 0;
    background-color: #e1e8ed;
  }
  .room {
    display: grid;
    padding: 10px 10px 0px 10px;
  }
  .room #title {
    font-size: 16px !important;
    color: #0a6c9f;
  }
  .room .option {
    margin-bottom: 8px !important;
    color: black;
  }
  .room-features {
    margin-top: 10px;
  }
  .room-features #title {
    color: #777777;
    line-height: 10px !important;
  }

  .choice {
    display: grid;
  }
  .option-title i {
    font-size: 17px;
  }
  .option-title span {
    font-weight: bold;
  }

  .more-amenities {
    color: #0a6c9f;
    cursor: pointer;
  }

  #room-feature {
    display: flex;
  }
  .icon-feature {
    font-size: 20px;
    color: #0a6c9f;
    cursor: pointer;
    transition: 0.4s;
    padding: 5px;
  }
  .icon-feature:hover {
    font-size: 20px;
    color: #0a6c9f;
    cursor: pointer;
    padding: 5px;
  }

  .fade-enter-active {
    transition: opacity 1.3s;
  }
  .fade-leave-active {
    transition: opacity 0s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .price-details {
    margin: 3px !important;
    /* font-size: 14px; */
    background: #eff4fa;
    padding: 10px 40px 10px 40px;
  }
</style>